import dayjs, { Dayjs } from 'dayjs'
import { AvailabilityContract } from 'models'
import { checkAvailability } from './checkAvailability'

//time span format for API
export const API_TIME_SPAN_FORMAT = 'HH:mm:ss'

export function availableDaysDisplayFormat(availableDays: string) {
    let data = availableDays.split(';')
    const dayToString = (d: number) => dayjs().day(d).format('ddd')
    // for data = [";"] , []
    if (data.length < 2) return `${dayToString(0)} - ${dayToString(6)}`
    let days = data
        .splice(1)
        .map((a) => parseInt(a))
        .sort((a, b) => a - b)
    let dayDiff = days.splice(0, 1)[0]
    let result = dayToString(dayDiff)
    for (let i = 0; i < days.length; i++) {
        dayDiff -= days[i] - 1
        if (dayDiff === 0) {
            result = result.replace(/(-[a-zA-Z]+)$/i, '')
            result += '-' + dayToString(days[i])
        }
        if (dayDiff !== 0) result += ', ' + dayToString(days[i])
        dayDiff = days[i]
    }
    return result
}

export const validateAvailability = (
    availabilities: AvailabilityContract[] | undefined | null,
    toDay: Dayjs | string = dayjs(),
) => {
    if (availabilities && availabilities.length > 0) {
        return availabilities.some((a) => checkAvailability(a, toDay))
    }
    return true
}
